// extracted by mini-css-extract-plugin
export default {"swiperImage":"style_swiperImage__sLjU-","thumbImg":"style_thumbImg__OY-Jj","mySwiper":"style_mySwiper__9Ow21","swiperSlide":"style_swiperSlide__nJkpb"};